// Regex para validar códigos de barras GS1 (case-insensitive con flag 'i')
// const GS1_BARCODE_REGEX =
// /^(?:\(02\)|02)\d{13,14}(?:\(20\)|20)\d{2}(?:\(15\)|15)\d{6}(?:\(37\)|37)\d{2,}$|^(?:\(10\)|10)[0-9A-Za-z]+$|^(?:\(00\)|00)\d{18}(?:\(240\)|240)[0-9A-Za-z]+$/i;
const GS1_BARCODE_REGEX =
  /^(?:\(02\)|02)\d{13,14}(?:\(20\)|20)\d{2}(?:\(15\)|15)\d{6}(?:\(37\)|37)\d{2,}$|^(?:\(10\)|10)(?=.*[A-Za-z])[0-9A-Za-z]+$|^(?:\(00\)|00)\d{18}(?:\(240\)|240)[0-9A-Za-z]+$/i;

// Función helper: valida y normaliza a uppercase
export const isValidGS1Barcode = (code) => {
  if (!code || typeof code !== "string") return false;
  const clean = code.trim();
  return GS1_BARCODE_REGEX.test(clean);
};

// Función extra: normaliza el código a uppercase (para usar después de validar)
export const normalizeGS1Barcode = (code) => {
  if (!isValidGS1Barcode(code)) return null;
  return code.trim().replace(/[()]/g, "").toUpperCase();
};
